import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <br /><br />
      © Uni Studio 2024. All rights reserved.
      <br />
      <br />
      유니스튜디오 | 대표: 전주옥 | 전화번호: 0507-1323-5912
    </footer>
  );
}

export default Footer;